import upperFirst from 'lodash/upperFirst';
export const _upperFirst = upperFirst;
